import { render, staticRenderFns } from "./NoTeam.vue?vue&type=template&id=4628a399&scoped=true&"
import script from "./NoTeam.vue?vue&type=script&lang=js&"
export * from "./NoTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628a399",
  null
  
)

export default component.exports